import { customContacs } from "../api/custom-contacts-api";
import { appState } from "../redux/redux-config";

export const CustomContacsApi = {
    deleteCustomContact: async function (customContactTypeId) {
        let token = appState().user.token;
        let result = await customContacs.deleteCustomContact(token, customContactTypeId);
        return result;
    },
    deleteCustomContactTypeForSpecificUser: async function (customContactTypeId, userId) {
        let token = appState().user.token;
        let result = await customContacs.deleteCustomContactTypeForSpecificUser(token, customContactTypeId, userId);
        return result;
    },
    saveCustomType: async function (payload) {
        let token = appState().user.token;
        let result = await customContacs.saveCustomType(token, payload);
        return result;
    },
    saveCustomContactTypeForSpecificUser: async function (payload, userId) {
        let token = appState().user.token;
        let result = await customContacs.saveCustomContactTypeForSpecificUser(token, payload, userId);
        return result;
    },
    editCustomContact: async function (customContactTypeId, payload) {
        let token = appState().user.token;
        let result = await customContacs.editCustomContact(token, customContactTypeId, payload);
        return result;
    },
    editCustomContactTypeForSpecificUser: async function (customContactTypeId, payload, userId) {
        let token = appState().user.token;
        let result = await customContacs.editCustomContactTypeForSpecificUser(token, customContactTypeId, payload, userId);
        return result;
    }
};
